<div class="card">
  <div class="card-body text-center">
    <h2 class="card-title mx-4">Sua sessão expirou</h2>
    
    <h4 class="card-text text-danger">Por favor faça login novamente para dar continuidade a sua votação! </h4>

    <!-- <a routerLink="/login"class="card-link mt-5">  <i class="fas fa-paper-plane mr-2 mt-3"></i>Login</a>   -->

  </div>
</div>
